import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import FilterDropdown from './FilterDropdown'

export default withTranslation()(function PeriodRangeFilter({ t, from, to, onApply, onClear }) {
  const [draftFrom, setDraftFrom] = useState(from ?? '')
  const [draftTo, setDraftTo] = useState(to ?? '')

  const activeLabel = from && to ? `${from} - ${to}` : null

  return (
    <FilterDropdown
      label={t('promo.listing.filters.period_range')}
      active={activeLabel}
      panel={({ close }) => (
        <div className="flex flex-col gap-3">
          <label className="flex flex-col gap-1 text-xs text-secondary">
            {t('promo.listing.filters.from')}
            <input
              type="date"
              value={draftFrom}
              onChange={(event) => setDraftFrom(event.target.value)}
              className="border border-border-lines rounded-lg px-2 py-1.5 text-sm text-dark-blue"
            />
          </label>

          <label className="flex flex-col gap-1 text-xs text-secondary">
            {t('promo.listing.filters.to')}
            <input
              type="date"
              value={draftTo}
              min={draftFrom || undefined}
              onChange={(event) => setDraftTo(event.target.value)}
              className="border border-border-lines rounded-lg px-2 py-1.5 text-sm text-dark-blue"
            />
          </label>

          <div className="flex items-center justify-between gap-2 pt-1">
            <button
              type="button"
              onClick={() => { setDraftFrom(''); setDraftTo(''); onClear(); close() }}
              className="text-sm font-medium text-secondary"
            >
              {t('promo.listing.filters.clear')}
            </button>

            <button
              type="button"
              onClick={() => { onApply(draftFrom, draftTo); close() }}
              className="bg-primary text-white text-sm font-medium rounded-full px-4 py-1.5"
            >
              {t('promo.listing.filters.apply')}
            </button>
          </div>
        </div>
      )}
    />
  )
})
